import {combine} from 'effector';
import {createGate} from 'effector-react';

import {fetchOrdersDetail, fetchOrderProductsGrid, fetchFormattedLabels} from 'api/orders';
import {RestError} from 'core/errors';
import {rootDomain} from 'core/rootDomain';
import {OrderDetailRaw, OrderDetailProductsRaw, FormattedLabelsForm} from 'types/orders';

const domain = rootDomain.createDomain('OrdersDetailDomain');
export const Gate = createGate<{id: string}>('OrdersDetailGate');

export const fetchDataFx = domain.createEffect({
    name: 'fetchDataFx',
    handler: fetchOrdersDetail,
});

export const fetchProductsFx = domain.createEffect({
    name: 'fetchProductsFx',
    handler: fetchOrderProductsGrid,
});

export const fetchFormattedLabelsFx = domain.createEffect({
    name: 'fetchFormattedLabelsFx',
    handler: fetchFormattedLabels,
});

export const commonData$ = domain.createStore<OrderDetailRaw | null>(null);
export const productsData$ = domain.createStore<Array<OrderDetailProductsRaw>>([]);
export const error$ = domain.createStore<RestError | null>(null);
export const currentGtin$ = domain.createStore<string | null>(null);

export const currentGtinChanged = domain.createEvent<string | null>();
export const fetchLabelsEvent = domain.createEvent<FormattedLabelsForm>();

export const commonDataState$ = combine({
    data: commonData$,
    error: error$,
    isLoading: fetchDataFx.pending,
});

export const productsTableState$ = combine({
    data: productsData$,
    error: error$,
    isLoading: fetchDataFx.pending,
});
